(function(){
  const input = document.getElementById('pcMegaSearchInput');
  const dropdown = document.getElementById('pcMegaResults');
  const defaultPanel = document.getElementById('pcMegaDefault');
  const livePanel = document.getElementById('pcMegaLive');
  const loadingPanel = document.getElementById('pcMegaLoading');
  const clearBtn = document.getElementById('pcMegaClear');
  const productsEl = document.getElementById('pcMegaProducts');
  const suggestionsEl = document.getElementById('pcMegaSuggestions');
  const collectionsEl = document.getElementById('pcMegaCollections');
  const pagesEl = document.getElementById('pcMegaPages');
  const viewAllEl = document.getElementById('pcMegaViewAll');
  const recentEl = document.getElementById('pcMegaRecent');

  if (!input || !dropdown) return;

  let debounceTimer;
  let currentQuery = '';
  const STORAGE_KEY = 'pc_recent_searches';
  const MAX_RECENT = 6;

  // Recent searches
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }
  function addRecent(q) {
    q = q.trim();
    if (!q) return;
    let recent = getRecent().filter(r => r.toLowerCase() !== q.toLowerCase());
    recent.unshift(q);
    if (recent.length > MAX_RECENT) recent = recent.slice(0, MAX_RECENT);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(recent));
  }
  function renderRecent() {
    const recent = getRecent();
    if (!recentEl) return;
    if (recent.length === 0) {
      recentEl.innerHTML = '<li class="pch-mega-search__empty">No recent searches</li>';
      return;
    }
    recentEl.innerHTML = recent.map(q =>
      '<li><a href="/search?q=' + encodeURIComponent(q) + '&type=product">' + escHtml(q) + '</a></li>'
    ).join('');
  }

  function escHtml(s) {
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function highlightMatch(text, query) {
    const idx = text.toLowerCase().indexOf(query.toLowerCase());
    if (idx === -1) return escHtml(text);
    return escHtml(text.slice(0, idx)) + '<mark>' + escHtml(text.slice(idx, idx + query.length)) + '</mark>' + escHtml(text.slice(idx + query.length));
  }

  function formatMoney(cents) {
    return '\u00a3' + (cents / 100).toFixed(2);
  }

  // Show/Hide
  function showDropdown() { dropdown.style.display = 'block'; }
  function hideDropdown() { dropdown.style.display = 'none'; }
  function showDefault() {
    renderRecent();
    defaultPanel.style.display = 'grid';
    livePanel.style.display = 'none';
    loadingPanel.style.display = 'none';
  }
  function showLive() {
    defaultPanel.style.display = 'none';
    livePanel.style.display = 'grid';
    loadingPanel.style.display = 'none';
  }
  function showLoading() {
    defaultPanel.style.display = 'none';
    livePanel.style.display = 'none';
    loadingPanel.style.display = 'flex';
  }

  // Predictive Search API
  async function doSearch(query) {
    currentQuery = query;
    showLoading();
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=hide';
      const res = await fetch(url);
      const data = await res.json();
      if (query !== currentQuery) return; // stale

      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      const pages = (data.resources && data.resources.results && data.resources.results.pages) || [];

      // Render suggestions (query-based)
      if (suggestionsEl) {
        const suggestions = [query, query + ' doors', query + ' flooring'].slice(0, 3);
        suggestionsEl.innerHTML = '<h4 class="pch-mega-search__heading"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00B67A" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>Suggestions</h4>' +
          suggestions.map(s =>
            '<a href="/search?q=' + encodeURIComponent(s) + '&type=product" class="pch-mega-search__suggest-item">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
            highlightMatch(s, query) + '</a>'
          ).join('');
      }

      // Render collections
      if (collectionsEl) {
        if (collections.length > 0) {
          collectionsEl.innerHTML = '<h4 class="pch-mega-search__heading"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00B67A" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>Collections</h4>' +
            collections.map(c =>
              '<a href="' + c.url + '" class="pch-mega-search__coll-item">' +
              (c.image ? '<img src="' + c.image.url + '&width=72" alt="">' : '<div style="width:36px;height:36px;background:#f3f4f6;border-radius:6px"></div>') +
              '<span>' + highlightMatch(c.title, query) + '</span></a>'
            ).join('');
        } else {
          collectionsEl.innerHTML = '';
        }
      }

      // Render pages
      if (pagesEl) {
        if (pages.length > 0) {
          pagesEl.innerHTML = '<h4 class="pch-mega-search__heading"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00B67A" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>Pages</h4>' +
            pages.map(p =>
              '<a href="' + p.url + '" class="pch-mega-search__suggest-item">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/></svg>' +
              highlightMatch(p.title, query) + '</a>'
            ).join('');
        } else {
          pagesEl.innerHTML = '';
        }
      }

      // Render products
      if (productsEl) {
        if (products.length > 0) {
          productsEl.innerHTML = products.map(p => {
            const img = p.image ? p.image.replace(/\.(jpg|png|webp)/, '_300x300.$1') : '';
            const price = p.price ? formatMoney(parseFloat(p.price) * 100) : '';
            const compare = p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price) ? formatMoney(parseFloat(p.compare_at_price) * 100) : '';
            return '<a href="' + p.url + '" class="pch-mega-search__product">' +
              (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<div style="aspect-ratio:1;background:#f3f4f6"></div>') +
              '<div class="pch-mega-search__product-info">' +
              '<div class="pch-mega-search__product-title">' + escHtml(p.title) + '</div>' +
              '<div><span class="pch-mega-search__product-price">' + price + '</span>' +
              (compare ? '<span class="pch-mega-search__product-compare">' + compare + '</span>' : '') +
              '</div></div></a>';
          }).join('');
        } else {
          productsEl.innerHTML = '<p style="color:#9ca3af;text-align:center;padding:20px;font-size:14px">No products found</p>';
        }
      }

      // View all link
      if (viewAllEl) {
        viewAllEl.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        viewAllEl.textContent = 'View all results for "' + query + '" \u2192';
      }

      showLive();
    } catch(e) {
      console.error('Search error:', e);
      showDefault();
    }
  }

  // Events
  input.addEventListener('focus', function() {
    showDropdown();
    if (input.value.trim().length >= 2) {
      doSearch(input.value.trim());
    } else {
      showDefault();
    }
  });

  input.addEventListener('input', function() {
    const q = input.value.trim();
    clearBtn.style.display = q.length > 0 ? 'block' : 'none';
    clearTimeout(debounceTimer);
    if (q.length >= 2) {
      debounceTimer = setTimeout(function() { doSearch(q); }, 250);
    } else {
      showDefault();
    }
  });

  clearBtn.addEventListener('click', function() {
    input.value = '';
    clearBtn.style.display = 'none';
    input.focus();
    showDefault();
  });

  // Save search on form submit
  document.getElementById('pcMegaSearchForm').addEventListener('submit', function() {
    addRecent(input.value.trim());
  });

  // Save search on suggestion/product click
  dropdown.addEventListener('click', function(e) {
    const q = input.value.trim();
    if (q) addRecent(q);
  });

  // Close on click outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.pch-mega-search')) {
      hideDropdown();
    }
  });

  // Keyboard navigation
  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      hideDropdown();
      input.blur();
    }
  });
})();
